import { useEffect } from "react";
import { Route, Routes } from "react-router-dom";
import { setDocumentTitle } from "@/lib/documentTitle";
import { useTranslation } from "react-i18next";

import { S2DataUploadTable } from "./table";
import { S2DataUploadEdit } from "./edit";

export default function S2DataUpload() {
  const { t } = useTranslation();

  useEffect(() => {
    setDocumentTitle(t("data_upload.document_title"));
  }, [t]);

  return (
    <Routes>
      <Route path=":id" element={<S2DataUploadEdit />} />
      <Route index element={<S2DataUploadTable />} />
    </Routes>
  );
}
